import { ComponentPropsWithoutRef } from 'react';
import { motion } from 'motion/react';
import { Dialog } from 'radix-ui';

import { cn, easeOutExpo } from '@components/primitives/utilities';

import css from './Drawer.module.css';

export type DrawerOverlayProps = ComponentPropsWithoutRef<typeof motion.div>;

export default function DrawerOverlay({
  className,
  ...props
}: DrawerOverlayProps) {
  return (
    <Dialog.Overlay asChild>
      <motion.div
        className={cn(css.overlay, className)}
        {...ANIMATIONS}
        {...props}
      />
    </Dialog.Overlay>
  );
}

const ANIMATIONS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3, ease: easeOutExpo },
};
